import axios from 'axios';
import { Product } from '../types';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const productApi = {
  getAll: async (params?: { category?: string; search?: string }) => {
    return api.get<Product[]>('/products', { params });
  },

  getById: async (id: string) => {
    return api.get<Product>(`/products/${id}`);
  },

  getCategories: async () => {
    return api.get<string[]>('/products/categories');
  },
};
